import Asset from '__core/shared/model/finance/Asset';
import Expense from '__core/shared/model/finance/Expense';
import Household from '__core/shared/model/finance/Household';
import HouseholdExpense from '__core/shared/model/finance/HouseholdExpense';
import Income from '__core/shared/model/finance/Income';
import Insurance from '__core/shared/model/finance/Insurance';
import Liability from '__core/shared/model/finance/Liability';
import AssetFinanceAssetCommitmentSchedule from '__core/shared/model/finance/AssetFinanceAssetCommitmentSchedule';
import AssetFinanceAssetCommitment from '__core/shared/model/finance/AssetFinanceAssetCommitment';
import Objective from '__core/shared/model/finance/Objective';
import ObjectiveApplicant from '__core/shared/model/finance/ObjectiveApplicant';
import OtherAdviser from '__core/shared/model/finance/OtherAdviser';
import Ownership from '__core/shared/model/finance/Ownership';
import { AssetType } from '__core/shared/model/finance/Asset.enum';
import { HouseholdExpenseType } from '__core/shared/model/finance/HouseholdExpense.enum';
import { HouseholdDescription } from '__core/shared/model/finance/HouseholdDescription.enum';
import { HouseholdLixiType } from '__core/shared/model/finance/HouseholdLixi.enum';
import { HouseholdCategory } from '__core/shared/model/finance/HouseholdCategory.enum';
import { HouseholdGroup } from '__core/shared/model/finance/HouseholdGroup.enum';
import { IncomeType } from '__core/shared/model/finance/Income.enum';
import { InsuranceType } from '__core/shared/model/finance/Insurance.enum';
import { LiabilityType } from '__core/shared/model/finance/Liability.enum';
import { ObjectivePayBallonOption } from '__core/shared/model/finance/ObjectivePayBallonOption.enum';
import { ObjectivePaymentPlanOption } from '__core/shared/model/finance/ObjectivePaymentPlanOption.enum';
import { ObjectivePaymentPreferenceOption } from '__core/shared/model/finance/ObjectivePaymentPreferenceOption.enum';
import { ObjectivePreferredDurationOption } from '__core/shared/model/finance/ObjectivePreferredDurationOption.enum';
import { OtherAdviserType } from '__core/shared/model/finance/OtherAdviser.enum';
import PropertyDetails from '__core/shared/model/finance/PropertyDetails';
import { PropertyDetailsType } from '__core/shared/model/finance/PropertyDetails.enum';
import financeService from './finance.service';
import stBestInterestDutyFlow from './bestInterestDutyFlow.component';

export default angular
  .module('st.Finance', ['st.Core'])
  .component('stBestInterestDutyFlow', stBestInterestDutyFlow)
  .factory('Asset', () => Asset)
  .factory('AssetType', () => AssetType)
  .factory('Expense', () => Expense)
  .factory('Household', () => Household)
  .factory('HouseholdExpense', () => HouseholdExpense)
  .factory('HouseholdExpenseType', () => HouseholdExpenseType)
  .factory('HouseholdDescription', () => HouseholdDescription)
  .factory('HouseholdLixiType', () => HouseholdLixiType)
  .factory('HouseholdCategory', () => HouseholdCategory)
  .factory('HouseholdGroup', () => HouseholdGroup)
  .factory('Income', () => Income)
  .factory('IncomeType', () => IncomeType)
  .factory('Insurance', () => Insurance)
  .factory('InsuranceType', () => InsuranceType)
  .factory('Liability', () => Liability)
  .factory('LiabilityType', () => LiabilityType)
  .factory('AssetFinanceAssetCommitmentSchedule', () => AssetFinanceAssetCommitmentSchedule)
  .factory('AssetFinanceAssetCommitment', () => AssetFinanceAssetCommitment)
  .factory('Objective', () => Objective)
  .factory('ObjectiveApplicant', () => ObjectiveApplicant)
  .factory('ObjectivePayBallonOption', () => ObjectivePayBallonOption)
  .factory('ObjectivePaymentPlanOption', () => ObjectivePaymentPlanOption)
  .factory('ObjectivePaymentPreferenceOption', () => ObjectivePaymentPreferenceOption)
  .factory('ObjectivePreferredDurationOption', () => ObjectivePreferredDurationOption)
  .factory('OtherAdviser', () => OtherAdviser)
  .factory('OtherAdviserType', () => OtherAdviserType)
  .factory('Ownership', () => Ownership)
  .factory('PropertyDetails', () => PropertyDetails)
  .factory('PropertyDetailsType', () => PropertyDetailsType)
  .service('financeService', financeService)
  .service('financesService', ($http, dataService, FINANCE) => ({
    getIncome: (params) => {
      return dataService.apiRequest(null, null, null, null, $http.post, FINANCE.API.INCOME, {
        params
      });
    },
    getExpenses: (params) => {
      return dataService.apiRequest(null, null, null, null, $http.post, FINANCE.API.EXPENSES, {
        params
      });
    },
    getAssets: (params) => {
      return dataService.apiRequest(null, null, null, null, $http.post, FINANCE.API.ASSETS, {
        params
      });
    },
    getLiabilities: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.LIABILITIES,
        {
          params
        }
      );
    },
    monthlyFinancialPosition: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.MONTHLY_FINANCIAL_POSITION,
        {
          params
        }
      );
    },
    assetFinanceAssetDetails: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.ASSET_DETAILS,
        {
          params
        }
      );
    },
    assetFinanceProductsSearch: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.PRODUCTS_SEARCH,
        {
          params
        }
      );
    },
    assetFinanceProductsCompare: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.PRODUCTS_COMPARE,
        {
          params
        }
      );
    },
    assetFinanceProductsCompareComparativeSaving: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.PRODUCTS_COMPARE_COMPARATIVE_SAVING,
        {
          params
        }
      );
    },
    assetFinanceFinanceProposal: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.FINANCE_PROPOSAL,
        {
          params
        }
      );
    },
    assetFinanceFinanceProposalamortizationSchedules: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.ASSET_FINANCE.FINANCE_PROPOSAL_AMORTIZATION_SCHEDULES,
        {
          params
        }
      );
    },
    homeLoanFundingWorksheet: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.HOME_LOAN.FUNDING_WORKSHEET,
        {
          params
        }
      );
    },
    homeLoanMaximumBorrowing: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.HOME_LOAN.MAXIMUM_BORROWING,
        {
          params
        }
      );
    },
    homeLoanProductsSearch: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.HOME_LOAN.PRODUCTS_SEARCH,
        {
          params
        }
      );
    },
    homeLoanProductsCompare: (params) => {
      return dataService.apiRequest(
        null,
        null,
        null,
        null,
        $http.post,
        FINANCE.API.HOME_LOAN.PRODUCTS_COMPARE,
        {
          params
        }
      );
    }
  }))
  .constant('FINANCE', {
    API: {
      INCOME: '/api/v1/finance/income/',
      EXPENSES: '/api/v1/finance/expenses/',
      ASSETS: '/api/v1/finance/assets/',
      LIABILITIES: '/api/v1/finance/liabilities/',
      MONTHLY_FINANCIAL_POSITION: '/api/v1/finance/monthly-financial-position/',
      ASSET_FINANCE: {
        ASSET_DETAILS: '/api/v1/finance/asset-finance/asset-details/',
        PRODUCTS_SEARCH: '/api/v1/finance/asset-finance/products-search/',
        PRODUCTS_COMPARE: '/api/v1/finance/asset-finance/products-compare/',
        FINANCE_PROPOSAL: '/api/v1/finance/asset-finance/finance-proposal/',
        FINANCE_PROPOSAL_AMORTIZATION_SCHEDULES:
          '/api/v1/finance/asset-finance/finance-proposal-amortization-schedules/'
      },
      HOME_LOAN: {
        FUNDING_WORKSHEET: '/api/v1/finance/home-loan/funding-worksheet/',
        MAXIMUM_BORROWING: '/api/v1/finance/home-loan/maximum-borrowing/',
        PRODUCTS_SEARCH: '/api/v1/finance/home-loan/products-search/',
        PRODUCTS_COMPARE: '/api/v1/finance/home-loan/products-compare/'
      }
    },
    BID_FLOWS: [
      { id: 1, name: 'Needs & objectives', isCompleted: false },
      { id: 2, name: 'Product requirements', isCompleted: false },
      { id: 3, name: 'Analysis, assessment & education', isCompleted: false },
      { id: 4, name: 'Options presented & recommendation', isCompleted: false },
      { id: 5, name: 'Signed authority to proceed', isCompleted: false }
    ]
  });
